const analytics = 'analytics';

type Resource = {
  controller: string;
  resource: string;
  version: number;
};

const RecordAnalytics: Resource = {
  controller: analytics,
  resource: '',
  version: 4
};

export { RecordAnalytics };
